// this adds a click anywhere feature to the grow brand card
// this is needed, because there are anchor tags on the card, and we cannot have nested links in html
// NOTE: this only applies specifically to the grow brand card
const growLinkCards = document.querySelectorAll('[data-click-grow-link]');
growLinkCards.forEach((card) => {
  const linkHref = card.getAttribute('data-click-grow-link-href');
  if (linkHref) {
    card.addEventListener('click', (event) => {
      // Prevent triggering the card click if a child link is clicked
      if (event.target.tagName === 'A' || event.target.closest('a')) {
        return;
      }
      window.open(linkHref, '_blank');
    });
  }
});
